import { computed, toValue, type MaybeRefOrGetter } from 'vue'

import { useParticipantsQuery } from './queries/useParticipantsQuery'

/**
 * Resolves a single event participant by id using one vue-query observer
 * (unlike `useParticipants()`, which creates three observers per call).
 *
 * Returns `null` while participants are loading or when `participantId` is
 * nullish. Throws when participants are loaded but the id is not found —
 * matching previous `getParticipantById` behavior.
 */
export const useParticipantById = (
  participantId: MaybeRefOrGetter<number | null | undefined>,
) => {
  const { data: participants } = useParticipantsQuery()

  return {
    participant: computed(() => {
      const id = toValue(participantId)

      if (id === null || id === undefined || !participants.value) {
        return null
      }

      const participant = participants.value.find((p) => p.id === id)
      if (!participant) {
        throw new Error('Participant not found')
      }
      return participant
    }),
  }
}
